import Navbar from 'components/common/navbar'
import { Outlet } from 'react-router-dom'
import './CaseLayout.scss'
import NetworkErrorDetection from 'components/common/network-error-detection'

const CaseLayout = () => {
  return (
    <div className="case-layout-wrapper">
      <Navbar isPrimaryLayout />
      <NetworkErrorDetection />
      <Outlet />
    </div>
  )
}

export default CaseLayout
